var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemThumbsUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18.3 19.778H9.767v-9.41l.34-.6 3.171-5.546c.583.002.945.32 1.11.51.164.19.428.596.346 1.177l-.349 2.443-.361 2.537h5.757zm-14.081 0h3.328v-8.89H4.219zM19.78 8.667h-3.2l.35-2.444a3.698 3.698 0 0 0-3.81-4.22c-.741.03-1.407.475-1.777 1.12L8.181 8.667H4.219A2.22 2.22 0 0 0 2 10.889v8.889A2.22 2.22 0 0 0 4.219 22H18.3c1.086 0 2.01-.786 2.19-1.857l1.478-8.889a2.222 2.222 0 0 0-2.189-2.587"
})));
export default SvgGemThumbsUp;